import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import DestinationFullMap from './components/DestinationFullMap'
import getStore from '../shared/store/getStore'

const el = document.querySelector('.destination-full-map')

if (el) {
  getStore().then((store) => {
    render(
      <Provider store={store}>
        <DestinationFullMap />
      </Provider>,
      el,
    )
  })
}